<template>
  <section class="unit-section">
    <!-- 배경 -->
    <div class="bg-layer">
      <div class="bg-gradient"></div>
      <div class="bg-pattern"></div>
    </div>

    <!-- 우측하단 워터마크 -->
    <img src="@/assets/logo/logo_symbol.png" alt="" class="watermark-logo" />

    <!-- Luxury Life 인트로 타이틀 -->
    <div class="intro-title" :class="{ 'fade-small': titleFaded }">
      <span class="luxury-word">Luxury</span>
      <span class="life-word">Life</span>
    </div>

    <!-- 메인 콘텐츠 -->
    <div class="unit-content" :class="{ visible: introComplete }">
      <!-- 좌측: 타이틀 영역 -->
      <div class="title-area">
        <p class="sub-title">삶의 품격을 높이는 세련된 공간</p>
        <h2 class="main-title">UNIT PLAN</h2>
        <p class="description">
          세련된 디자인과 편안한 분위기<br />
          트렌디하면서도 실속있는 공간을 만듭니다
        </p>
      </div>

      <!-- 중앙: 면적 표시 + 타입 선택 -->
      <div class="center-area">
        <div class="area-display">
          <transition name="fade" mode="out-in">
            <div class="area-number" :key="activeUnit">
              <span class="number">{{ units[activeUnit].area }}</span>
              <span class="unit">m<sup>2</sup></span>
            </div>
          </transition>
          <div class="area-line"></div>
          <transition name="fade" mode="out-in">
            <span class="type-badge" :key="activeUnit" :class="{ 'sold-out': units[activeUnit].soldOut }">
              {{ units[activeUnit].soldOut ? '마감완료' : '분양중' }}
            </span>
          </transition>
        </div>

        <!-- 타입 탭 (면적별 그룹) -->
        <div class="type-tabs">
          <div
            v-for="(group, groupIndex) in areaGroups"
            :key="groupIndex"
            class="tab-group"
          >
            <span class="group-label">{{ group.label }}</span>
            <div class="group-tabs">
              <button
                v-for="(unit, unitIndex) in group.units"
                :key="unitIndex"
                class="type-tab"
                :class="{ active: activeUnit === unit.index }"
                @click="activeUnit = unit.index"
              >
                {{ unit.type }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 우측: 유닛 상세 정보 카드 -->
      <div class="info-area">
        <transition name="slide-fade" mode="out-in">
          <div class="info-card" :key="activeUnit">
            <!-- 타입명 -->
            <div class="card-header">
              <h3 class="type-name">{{ units[activeUnit].name }}</h3>
              <div class="household-info">
                <span class="household-count">{{ units[activeUnit].households }}</span>
                <span class="household-label">세대</span>
                <span v-if="units[activeUnit].soldOut" class="sold-out-badge">마감완료</span>
              </div>
            </div>

            <!-- 분양 상태 -->
            <div class="status-row">
              <div class="status-item">
                <span class="status-label">분양상태</span>
                <span class="status-value" :class="{ 'sold-out': units[activeUnit].soldOut }">
                  {{ units[activeUnit].soldOut ? '마감완료' : '분양중' }}
                </span>
              </div>
              <div class="status-item">
                <span class="status-label">전용면적</span>
                <span class="status-value">{{ units[activeUnit].area }}㎡</span>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'UnitSection',
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeUnit: 0,
      titleFaded: false,
      introComplete: false,
      introShown: false,
      units: [
        {
          type: '59',
          name: '59타입',
          area: '59',
          households: '114',
          soldOut: true
        },
        {
          type: '74',
          name: '74타입',
          area: '74',
          households: '115',
          soldOut: true
        },
        {
          type: '84A',
          name: '84A타입',
          area: '84',
          households: '1,118',
          soldOut: false
        },
        {
          type: '84A-1',
          name: '84A-1타입',
          area: '84',
          households: '398',
          soldOut: false
        },
        {
          type: '84B',
          name: '84B타입',
          area: '84',
          households: '67',
          soldOut: false
        }
      ]
    }
  },
  computed: {
    areaGroups() {
      const groups = [
        { label: '59㎡', units: [] },
        { label: '74㎡', units: [] },
        { label: '84㎡', units: [] }
      ]

      this.units.forEach((unit, index) => {
        const groupIndex = unit.area === '59' ? 0 : unit.area === '74' ? 1 : 2
        groups[groupIndex].units.push({
          ...unit,
          index
        })
      })

      return groups.filter(g => g.units.length > 0)
    }
  },
  watch: {
    isActive(newVal) {
      if (newVal && !this.introShown) {
        this.startIntroAnimation()
      }
    }
  },
  methods: {
    startIntroAnimation() {
      // 1.2초 후 타이틀 페이드 & 축소
      setTimeout(() => {
        this.titleFaded = true
      }, 1200)
      // 2.5초 후 콘텐츠 표시
      setTimeout(() => {
        this.introComplete = true
        this.introShown = true
      }, 2500)
    }
  }
}
</script>

<style scoped>
.unit-section {
  width: 100%;
  height: 100vh;
  position: relative;
  overflow: hidden;
  background: #0a0a0a;
}

/* 배경 */
.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.bg-gradient {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(ellipse at 30% 20%, rgba(163, 32, 53, 0.15) 0%, transparent 50%),
              radial-gradient(ellipse at 70% 80%, rgba(163, 32, 53, 0.1) 0%, transparent 50%),
              linear-gradient(180deg, #0a0a0a 0%, #1a1a1a 50%, #0a0a0a 100%);
}

.bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.03;
  background-image:
    linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 100px 100px;
}

/* 워터마크 */
.watermark-logo {
  position: absolute;
  bottom: -15%;
  right: -10%;
  width: 900px;
  height: auto;
  opacity: 0.05;
  pointer-events: none;
  z-index: 1;
}

/* Luxury Life 인트로 타이틀 */
.intro-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
  transition: all 1.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.intro-title.fade-small {
  top: 6%;
  transform: translate(-50%, 0);
  opacity: 1;
}

.luxury-word {
  font-family: var(--font-serif);
  font-size: 180px;
  font-weight: 400;
  font-style: italic;
  color: #fff;
  line-height: 0.85;
  letter-spacing: -5px;
  transition: all 1.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.life-word {
  font-family: var(--font-serif);
  font-size: 180px;
  font-weight: 400;
  font-style: italic;
  color: var(--rayone-primary);
  line-height: 0.85;
  letter-spacing: -5px;
  transition: all 1.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.intro-title.fade-small .luxury-word,
.intro-title.fade-small .life-word {
  font-size: 48px;
  letter-spacing: 2px;
}

.intro-title.fade-small .luxury-word {
  color: rgba(255, 255, 255, 0.9);
}

.intro-title.fade-small .life-word {
  color: var(--rayone-primary);
}

/* 메인 콘텐츠 */
.unit-content {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 80px;
  gap: 80px;
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 1s ease, transform 1s ease;
}

.unit-content.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 좌측: 타이틀 영역 */
.title-area {
  flex: 0 0 auto;
  max-width: 380px;
}

.sub-title {
  font-family: var(--font-pretendard);
  font-size: 14px;
  font-weight: 400;
  color: var(--rayone-primary-light);
  letter-spacing: 3px;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.main-title {
  font-family: var(--font-luxury);
  font-size: 56px;
  font-weight: 500;
  color: #fff;
  letter-spacing: 8px;
  margin-bottom: 24px;
  line-height: 1.1;
}

.description {
  font-family: var(--font-pretendard);
  font-size: 15px;
  line-height: 1.9;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

/* 중앙: 면적 표시 */
.center-area {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 50px;
}

.area-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.area-number {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

.area-number .number {
  font-family: var(--font-serif);
  font-size: 140px;
  font-weight: 400;
  color: #fff;
  line-height: 1;
}

.area-number .unit {
  font-family: var(--font-pretendard);
  font-size: 28px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
}

.area-number .unit sup {
  font-size: 16px;
}

.area-line {
  width: 1px;
  height: 40px;
  background: linear-gradient(to bottom, transparent, var(--rayone-primary), transparent);
}

.type-badge {
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 500;
  color: var(--rayone-primary-light);
  padding: 12px 24px;
  border: 1px solid rgba(163, 32, 53, 0.5);
  letter-spacing: 3px;
  text-transform: uppercase;
}

.type-badge.sold-out {
  color: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.15);
}

/* 타입 탭 */
.type-tabs {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.tab-group {
  display: flex;
  align-items: center;
  gap: 16px;
}

.group-label {
  font-family: var(--font-pretendard);
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.3);
  min-width: 45px;
  letter-spacing: 1px;
}

.group-tabs {
  display: flex;
  gap: 8px;
}

.type-tab {
  min-width: 40px;
  height: 40px;
  padding: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.15);
  font-family: var(--font-pretendard);
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.4);
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.type-tab:hover {
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
}

.type-tab.active {
  background: var(--rayone-primary);
  border-color: var(--rayone-primary);
  color: #fff;
}

/* 우측: 정보 카드 */
.info-area {
  flex: 0 0 auto;
  width: 380px;
}

.info-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  padding: 40px;
}

/* 카드 헤더 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 32px;
}

.type-name {
  font-family: var(--font-pretendard);
  font-size: 24px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
}

.household-info {
  text-align: right;
  display: flex;
  align-items: baseline;
  gap: 6px;
}

.household-count {
  font-family: var(--font-serif);
  font-size: 32px;
  font-weight: 400;
  color: var(--rayone-primary-light);
  line-height: 1;
}

.household-label {
  font-family: var(--font-pretendard);
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
}

.sold-out-badge {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 600;
  color: #fff;
  background: rgba(255, 255, 255, 0.15);
  padding: 4px 10px;
  letter-spacing: 1px;
  margin-left: 4px;
}

/* 분양 상태 */
.status-row {
  display: flex;
  gap: 32px;
}

.status-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.status-label {
  font-family: var(--font-pretendard);
  font-size: 11px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.3);
  letter-spacing: 2px;
  text-transform: uppercase;
}

.status-value {
  font-family: var(--font-pretendard);
  font-size: 16px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
}

.status-value.sold-out {
  color: rgba(255, 255, 255, 0.3);
}

/* 트랜지션 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-fade-enter-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-fade-leave-active {
  transition: all 0.3s ease;
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-20px);
}
</style>
